import PropTypes from 'prop-types'
import ActiveRecord from 'model/activeRecord'
import { isNil } from 'ramda'

class InteractionModality extends ActiveRecord {
  constructor(init) {
    super(init)
    // console.log('> InteractionModality constructor -', init)
    if (isNil(init)) return undefined
    this._active = init.active
    this._code = init.code
    this._name = init.name
  }

  static shape = {
    id: PropTypes.string.isRequired,
    active: PropTypes.bool,
    code: PropTypes.string,
    name: PropTypes.string
  }

  get active() {
    return this._active
  }

  get code() {
    return this._code
  }

  get name() {
    return this._name
  }
}

export default InteractionModality
